// extracted by mini-css-extract-plugin
export default {"viewProperties":"green_viewProperties__OwzfJ"};